import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import { ref, onMounted, nextTick} from 'vue'
  import { useMethods} from "@/composables/methods";
  import EventBus from "@/composables/EventBus";
  interface Result {
    min?: number,
    max?: number,
    id?: string
  }

  // --- DATA ---
  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    id: null,
    min: null,
    max: null,
    index: null
  },
  emits: ["add-result"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'add-result', min:number,max:number, id:string ):void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    title?: string
    id?:string
    min?: string
    max?: string
    index?:string
  }

  

  

  const visible = ref<boolean>(false)
  const id = ref<string>("")
  const results = ref<HTMLDivElement|null>()

  // --- METHODS ---
  const { getId} = useMethods()
  const addResult = () => {
    let obj:Result = {
      min: props.min,
      max: props.max,
      id: props.id

    };

    emit('add-result', obj)
  }

  // --- LIFECYCLE ---
  onMounted(() => {
    id.value = getId(props.title!)+'_'+props.index

    addResult()

    EventBus.on('show-result', (id:string) => {
      if (props.id === id) {
        visible.value = true
        nextTick(() => {
          if (results.value) {
            results.value.scrollIntoView({behavior: "smooth"});
            results.value.focus({preventScroll: true})
          }
        })
      } else {
        visible.value = false;
      }
    })
  })

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: id.value,
    ref_key: "results",
    ref: results
  }, [
    _createElementVNode("h2", null, [
      _createElementVNode("strong", null, _toDisplayString(__props.title), 1)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1)), [
    [_vShow, visible.value]
  ])
}
}

})